import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { AppContext } from '../../../app-context';
import { useEffect, useState, useContext } from 'react';
import { getProductRank } from '../amazon.services';
import { formatDate, formatTo0Decimal, isEmpty, isEmptyArray } from '../../common/util.services';
import { PAGE_SIZE } from '../../common/constants';

const RankProductComponent = (props: any) => {

  const columns: GridColDef[] = [
    { field: 'product', headerName: 'Product', width: 175 },
    { field: 'rank', headerName: 'Rank', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => isEmpty(value) ? 'NA' : formatTo0Decimal(value)
    },
    { field: 'latestUpdate', headerName: 'Latest Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (value: any) => formatDate(value)
    }
  ];
  
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [rankData, setRankData] = useState(rows);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getProductRank(page, pageSize, appContext,
        (response: any) => {
          setRankData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setSuccessMessage(response.message);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
        });
      }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <div>
    <IGridComponent title='' showAddBtn={false} rows={rankData} columns={columns} maxHeight={500}
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      getRowId={(row: any) => row.product}/>
  </div>
}

export default RankProductComponent;